import { faBookOpen, faConciergeBell, faHandsHelping } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";

export function SubNavGestaoVendaAtendimentos() {
    const { UserInfor } = useUserInfor();

    return (
        <>
            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (tela.ID_TELA === 552) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                        ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS.DS_PATH
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                      onClick={() => {}}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faHandsHelping}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Meus Atendimentos
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (tela.ID_TELA === 551) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                        ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.GRUPO.DS_PATH //tem que alterar 
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                      onClick={() => {}}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faConciergeBell}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Fila de Atendimentos
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}
                {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (tela.ID_TELA === 551) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <NavLink
                                      to={
                                        ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH //tem que alterar 
                                      }
                                      exact
                                      activeClassName="active"
                                      className="menu-link"
                                      onClick={() => {}}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faBookOpen}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Todos Atendimentos
                                      </span>
                                  </NavLink>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}
        </>
    );
}
